import React, { useState } from 'react';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqs } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-49" data-mp="1gjlrlfcegua0">
      <div className="mx-auto max-w-2xl" data-id="element-50" data-mp="1glge2y3bkug7">
        <div className="text-center" data-id="element-51" data-mp="248xyu9o62s9o">
          <HelpCircleIcon className="mx-auto h-9 w-9 text-forest-800" aria-hidden="true" data-id="element-52" data-mp="249zk16ywcv54" />
        </div>
        <div className="mt-4" data-id="element-53" data-mp="28cvxkj9ky127">
          <SectionHeading id="faq-title" title={<>
                Preguntas <span className="mark-lime" data-id="element-55" data-mp="1uhae0rm489h6">frecuentes</span>
              </>} data-id="element-54" data-mp="1ujmqip93trmu" />
        </div>

        <ul className="mt-10 space-y-3" data-id="element-56" data-mp="1zgn0hb92rej8">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.q} className={`overflow-hidden rounded-2xl border-2 bg-white shadow-card transition-colors ${isOpen ? 'border-lime-200' : 'border-forest-100'}`} data-id="element-57" data-mp="2rzk63yqck8im" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-forest-50 focus:outline-none focus-visible:ring-4 focus-visible:ring-lime-400/40" data-id="element-58" data-mp="10uhz2ukkca1c">
                  <span className="font-display text-base font-bold text-forest-800 sm:text-lg" data-id="element-59" data-mp="1ohyl5fh8j8ju">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-none text-forest-700 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-60" data-mp="1xjzgu7wtlmje" />
                </button>

                <div id={panelId} className={`faq-panel ${isOpen ? 'is-open' : ''}`} data-id="element-61" data-mp="35ygtjpjathq">
                  <div data-id="element-62" data-mp="37rpf4jpjnsd">
                    <p className="px-5 pb-5 text-[13px] leading-relaxed text-forest-900/75" data-id="element-63" data-mp="3uchowr3zk5cc">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}